import VZFView from './VZFView'

export default VZFView
